import React from "react";
import "./Input.scss";

function Input({ className = "", type = "text", ...props }) {
  return (
    <input style={{fontSize:"10px"}}
      type={type}
      data-slot="input"
      className={`custom-input ${className}`}
      {...props}
    />
  );
}

export { Input };
